import { ActionInterface } from "../../../Interface/ActionInterface";
// import Constants from "../../../Action/Constants";
// import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";

interface StateInterface {
  byId: any;
  allIds: string[];
};

const initialState: StateInterface = {
  byId: {},
  allIds: [],
};

export const companiesReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {

    default:
      return state;
  }
};
